import { createContext, useContext } from 'react';

export type IntlLocale = {
  code: string;
  name: string;
};

type IntlContextState = {
  loading: boolean;
  language: string;
  languages: IntlLocale[];
};

export const IntlContextProps = {
  loading: false,
  language: '',
  languages: [],
};

export const IntlContext = createContext<IntlContextState>(IntlContextProps);

export const useIntlContext = () => useContext(IntlContext);
